// src/components/Login/Home.jsx
import React, { Component } from 'react'
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import './login.css'
import logo from "../../bilder/logo_adlatus.png"
import Grid from "@material-ui/core/Grid";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Dialog from "@material-ui/core/Dialog";
import withStyles from "@material-ui/core/styles/withStyles";
import Moved from "./Moved"
import { Paper } from "@material-ui/core";

const useStyles = theme => ({
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
  },
  button: {
    margin: theme.spacing(2)
  },
  textField: {
    margin: theme.spacing(1),
    minWidth: 280
  }
});

class Home extends Component {
  state = this.getInitState();

  getInitState() {
    return {
      username: '',
      password: '',
      firma: '',
      email: '',
      name: '',
      vorname: '',
      open: false,
      moved: false,

      // 2FA state
      step: 'password',    // 'password' | 'otp'
      otp: '',
      tempToken: null,
      loading: false,
      error: null
    };
  }

  handleChange = name => ({ target: { value } }) => this.setState({ [name]: value });

  handleOtpChange = ({ target: { value } }) => {
    const clean = value.replace(/\D/g, '').slice(0, 6);
    this.setState({ otp: clean });
  }
  handleLogin = (event) => {
    event.preventDefault();
    this.setState({ loading: true, error: null });
  
    fetch('/api/authenticate', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include', // make sure Set-Cookie is accepted (same-origin is usually fine, but explicit is safe)
      body: JSON.stringify({
        username: this.state.username,
        password: this.state.password
      })
    })
      .then(async (res) => {
        let data = null;
        try { data = await res.json(); } catch {} // ok if no body
  
        if (res.status === 401) {
          return alert((data && data.error) || 'Ungültige Anmeldedaten');
        }
        if (res.status === 403 && data?.requirePasswordChange) {
          return alert('Passwort abgelaufen. Bitte zuerst ändern.');
        }
        // 2FA handoff?
        if (data?.next === '2fa' && data?.tempToken) {
          return this.setState({ step: 'otp', tempToken: data.tempToken, otp: '' });
        }
  
        // Full login success (cookie set)
        if (res.ok) {
          return this.props.history.push('/');
        }
  
        alert((data && data.error) || 'Login fehlgeschlagen');
      })
      .catch((err) => {
        console.error(err);
        alert('Error logging in. please try again');
      })
      .finally(() => this.setState({ loading: false }));
  }

  handleVerifyOtp = (e) => {
    e.preventDefault();
    const { otp, tempToken } = this.state;
    if (!otp || otp.length < 6) return alert('Bitte 6-stelligen Code eingeben');

    this.setState({ loading: true, error: null });
    fetch('/api/2fa/verify', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include', // accept Set-Cookie from server
        body: JSON.stringify({ code: otp, tempToken })
      })
      .then(async (res) => {
        if (res.status === 200) {
          this.props.history.push('/');
        } else {
          let data = {};
          try { data = await res.json(); } catch (_) {}
          if (res.status === 401) {
            alert(data?.error || 'Code ungültig');
          } else if (res.status === 429) {
            alert(data?.error || 'Zu viele Versuche. Bitte neuen Code anfordern.');
          } else {
            alert(data?.error || 'Verifizierung fehlgeschlagen');
          }
        }
      })
      .catch((err) => {
        console.error(err);
        alert('Netzwerkfehler. Bitte erneut versuchen.');
      })
      .finally(() => this.setState({ loading: false }));
  }

  handleToggleRegister = () => {
    this.setState(prev => ({ ...prev, open: !prev.open }));
  }

  handleRegister = (event) => {
    event.preventDefault();

    fetch('/api/me', {
      method: 'POST',
      body: JSON.stringify({
        username: this.state.username,
        password: this.state.password,
        firma: this.state.firma,
        email: this.state.email,
        name: this.state.name,
        vorname: this.state.vorname
      }),
      headers: { 'Content-Type': 'application/json' }
    }).then(res => {
      if (res.status === 200) {
        alert('Welcome to the club');
        this.handleToggleRegister();
      } else {
        alert('Registrierung fehlgeschlagen');
      }
    }).catch((e) => {
      console.error(e);
      alert('Registrierung fehlgeschlagen');
    });
  }

  check = () => {
    this.setState({ ...this.state, moved: false });
  }

  renderPasswordStep(classes) {
    return (
      <>
        <Grid item>
          <img src={logo} alt={'logo'} />
        </Grid>

        <Grid item>
          <TextField
            id='username'
            variant='filled'
            label='Username'
            onChange={this.handleChange("username")}
            className={classes.textField}
          />
        </Grid>

        <Grid item>
          <TextField
            id='Password'
            variant='filled'
            label='Passwort'
            onChange={this.handleChange("password")}
            type="password"
            autoComplete="current-password"
            className={classes.textField}
          />
        </Grid>

        <Grid item>
          <Button
            className={classes.button}
            id='register'
            variant='contained'
            color='primary'
            onClick={this.handleToggleRegister}
          >
            Registrieren
          </Button>

          <Button
            id='login'
            variant='contained'
            color='primary'
            onClick={this.handleLogin}
            disabled={this.state.loading}
          >
            {this.state.loading ? '…' : 'Login'}
          </Button>
        </Grid>
      </>
    );
  }

  renderOtpStep(classes) {
    return (
      <>
        <Grid item>
          <img src={logo} alt={'logo'} />
        </Grid>

        <Grid item>
          <TextField
            id='otp'
            variant='filled'
            label='6-stelliger Code'
            value={this.state.otp}
            onChange={this.handleOtpChange}
            inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', maxLength: 6 }}
            helperText='Wir haben Ihnen einen Code gesendet (gültig ~10 Minuten).'
            className={classes.textField}
            autoFocus
          />
        </Grid>

        <Grid item>
          <Button
            variant='contained'
            color='primary'
            onClick={this.handleVerifyOtp}
            disabled={this.state.loading}
          >
            {this.state.loading ? '…' : 'Code bestätigen'}
          </Button>

          <Button
            className={classes.button}
            variant='text'
            onClick={() => this.setState({ step: 'password', otp: '', tempToken: null })}
          >
            Zurück
          </Button>
        </Grid>
      </>
    );
  }

  render() {
    const { classes } = this.props;
    const { open, moved, step } = this.state;

    return (
      <Paper className={classes.root}>
        <Grid
          direction="column"
          justify="center"
          alignItems="center"
          container
          spacing={2}
        >
          {step === 'password'
            ? this.renderPasswordStep(classes)
            : this.renderOtpStep(classes)}
        </Grid>

        <Dialog open={open} onClose={this.handleToggleRegister}>
          <DialogTitle>Registrierung</DialogTitle>
          <DialogContent>Bitte das nachfolgende Formular ausfüllen</DialogContent>

          <form className='centering'>
            <TextField className={classes.textField} id='name' label='Name' onChange={this.handleChange('name')} />
            <TextField className={classes.textField} id='firma' label='Firma' onChange={this.handleChange('firma')} />
            <TextField className={classes.textField} id='vorname' label='Vorname' onChange={this.handleChange('vorname')} />
            <TextField className={classes.textField} id='usernameReg' label='Username' onChange={this.handleChange('username')} />
            <TextField className={classes.textField} id='email' label='email' onChange={this.handleChange('email')} />
            <TextField className={classes.textField} id='passwordReg' label='Passwort' type="password" onChange={this.handleChange('password')} />
            <Button
              color="primary"
              className={classes.textField}
              variant="contained"
              onClick={this.handleRegister}
            >
              Registrieren
            </Button>
          </form>
        </Dialog>

        <Moved check={this.check} moved={moved} />
      </Paper>
    );
  }
}

export default withStyles(useStyles)(Home);
